var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.503,
    height: 34.705,
    viewBox: "0 0 47.503 34.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "subscribed-svgrepo-com",
    d: "M6.72,13.78c0,6.175,3.431,11.474,8.255,11.474s8.249-5.3,8.249-11.474S20.3,4,14.976,4,6.72,7.606,6.72,13.78ZM1.59,36.956Q4.258,38.7,14.982,38.7t13.392-1.744a1.085,1.085,0,0,0,.488-.983q-.495-7.249-13.889-7.251T1.1,35.978A1.085,1.085,0,0,0,1.59,36.956Zm46.377-18.4A2.169,2.169,0,1,0,44.9,15.484L35.588,24.8l-4.974-4.974a2.169,2.169,0,1,0-3.067,3.067L34.055,29.4a2.169,2.169,0,0,0,3.067,0L47.967,18.551Z",
    transform: "translate(-1.1 -3.997)",
    fill: "#b1d5d5",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribed);
export default __webpack_public_path__ + "static/media/subscribed.f1ff04b586da1ae78088d17b4ab25f89.svg";
export { ForwardRef as ReactComponent };